module.exports = __webpack_public_path__ + "static/img/profile-icon17.f720b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon17.png
// module id = 2965
// module chunks = 1